const initialState = {
    inputFullname: '',
    inputMobile: '',
    inputEmail: '',
    inputComment: '',
    
};
const suggestions = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_SUGGESTIONS':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default suggestions;
